import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { modulo13 } from "../../../routes/Module13";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import { faSignLanguage } from "@fortawesome/free-solid-svg-icons";
import Imagen1 from "../../../images/modulo13/terrenosucio.png";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo13/Unidad3Actividad7.mp3";

const Actividad9 = () => {
  const infoUnidad = modulo13.content[2];
  const infoAct = modulo13.content[2].activities[9];
  const crumbs = [
    {
      title: modulo13.title,
      url: "/" + modulo13.url,
    },
    {
      title:
        modulo13.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titlePrev: `${modulo13.content[2].name}: ${modulo13.content[2].activities[8].name}`,
    linkPrev: `${modulo13.url}/${modulo13.content[2].path}/${modulo13.content[2].activities[8].path}`,
    titleNext: `${modulo13.content[2].name}: ${modulo13.content[2].activities[10].name}`,
    linkNext: `${modulo13.url}/${modulo13.content[2].path}/${modulo13.content[2].activities[10].path}`,
  };
  const metadata = {
    color: modulo13.color,
    title: `${modulo13.title} - ${infoAct.name}`,
    name: modulo13.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo13.color} hat-text`}>
          <FontAwesomeIcon icon={faSignLanguage} /> Hacemos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <ul>
        <li>
          En la siguiente ilustración, puedes observar un parque en un barrio de
          una gran ciudad. Como puedes ver, el parque no se usa porque está
          lleno de objetos desechados.
        </li>
        <li>
          Trabaja con un compañero, compañera o familiar e identifiquen todos
          los objetos que aparecen en la ilustración. En la siguiente actividad
          los usarán para mejorar este parque.
        </li>
      </ul>

      <img src={Imagen1} className="img-fluid" alt="Peruanos" />

      <GuiaDocente>
        <ul>
          <li>
            Explique la importancia de involucrarse en el espacio que habitan.
            Las siguientes actividades tienen como objetivo mostrar que los
            ciudadanos y ciudadanas somos responsables de tomar acción en
            nuestras ciudades.
          </li>
          <li>
            Lea la primera indicación: En la siguiente ilustración, puedes
            observar un parque en un barrio de una gran ciudad. Como puedes ver,
            el parque no se usa porque está lleno de objetos desechados. Pida
            que observen los detalles que se muestran en la ilustración. Recoja
            algunas de sus opiniones a partir de las siguientes preguntas:
            <ul>
              <li>
                <i>
                  “¿Qué problema presenta el parque? (Posible respuesta: Está
                  sucio, lleno de objetos que no se usan).
                </i>
              </li>
              <li>
                <i>
                  ¿Cómo llegaron esos deshechos allí? (Posible respuesta:
                  Probablemente el parque estaba poco cuidado y no se usaba.
                  Poco a poco la gente lo fue usando de basurero).
                </i>
              </li>
              <li>
                <i>
                  ¿Alguno de ustedes ha visto algún parque poco cuidado en su
                  distrito? ¿Cuál? ¿Qué problema(s) presenta? (Respuesta libre).
                </i>
              </li>
              <li>
                <i>
                  ¿Cómo debería ser este espacio público? (Posible respuesta:
                  Debería ser un espacio con plantas y flores. Debería tener
                  rampas de acceso para sillas de ruedas y coches de bebés. Se
                  podría poner algunas bancas y también construir una zona con
                  juegos para niños y niñas)”.
                </i>
              </li>
            </ul>
          </li>
          <li>
            Lea la segunda indicación: Trabaja con
            un compañero, compañera o familiar e identifiquen todos los objetos que
            aparecen en la ilustración. En la siguiente actividad los usarán
            para mejorar este parque. Déles un tiempo para trabajar. Pregunte
            qué objetos identificaron en la ilustración. Haga una lista y déjela
            allí para usarla en la siguiente actividad:
            <ul>
              <li>
                <i>
                  “¿Qué objetos ven en la ilustración? (Posible respuesta:
                  Llantas viejas de distintos tamaños. Algunas podrían ser de
                  bicicletas, otras de auto o de un camión. Piedras. Botellas de
                  plástico y de vidrio. Troncos y maderas. Barriles de metal.
                  Sogas. Tarros de pintura. Bolsas y costales de plástico.
                  Cajones de botellas vacíos)”.
                </i>
              </li>
            </ul>
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad9;
